import type { StickerPlacement } from "@/src/services/api/posts/engagement-functions";

type T = (key: string, opts?: Record<string, unknown>) => string;

/** "Added by …" for a placed sticker: you, the placer's display name, or a neutral fallback. */
export const stickerAddedBy = (
  s: Pick<StickerPlacement, "userId" | "displayName">,
  viewerId: string | undefined,
  t: T,
): string => {
  if (viewerId && s.userId === viewerId) return t("LABEL_STICKER_ADDED_BY_YOU");
  const name = s.displayName?.trim();
  return name ? t("LABEL_STICKER_ADDED_BY", { name }) : t("LABEL_STICKER_ADDED_BY_SOMEONE");
};

/** Stickers that belong on one target: an attachment index, or the card body (-1). */
export const stickersFor = (stickers: readonly StickerPlacement[] | null | undefined, mediaIndex: number) =>
  (stickers ?? []).filter((s) => s.mediaIndex === mediaIndex);
